import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Button, Divider, Icon, IconButton,
    List, ListItem, ListItemText, makeStyles, Popover
} from "@material-ui/core";
import {Draggable, Droppable} from 'react-beautiful-dnd'
import {set} from "object-path-immutable";
import FormField from "../../../../../../../Utils/Form/Fields/FormField";
import Card from "@material-ui/core/Card";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";

const styles = () => ({
    cardContentWrapper: {
        height: 120,
        width: 180,
        overflowX: "hidden"
    },
    cardContentRoot: {
        padding: 0
    },
    list: {
        paddingTop: 0
    },
    editIcon: {
        padding: 0
    },
    table: {
        width: '100%',
        marginTop: '5px',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    formActionsWrapper: {
        margin: '5px 5px 5px 0',
        textAlign: 'right',
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
});
const useStyles = makeStyles(() => ({
    cardContentWrapper: {
        height: 120,
        width: 180,
        overflowX: "hidden"
    },
    cardContentRoot: {
        padding: 0
    },
    list: {
        paddingTop: 0
    },
    editIcon: {
        padding: 0
    },
    table: {
        width: '100%',
        marginTop: '5px',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    formActionsWrapper: {
        margin: '5px 5px 5px 0',
        textAlign: 'right',
    },
    subHeader: {
        lineHeight: 1.32
    },
    fieldset: {
        padding: 2,
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    }
}))

class ValuesColumns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnInEdit: null,
            anchorEl: null,
            errorComponent: false,
            columnSchema: {
                name: {
                    type: "string",
                    name: "name",
                    label: "Name",
                    path: "name",
                    disabled: true
                },
                label: {
                    type: "string",
                    name: "label",
                    label: "Label",
                    path: "label",
                    multiLanguage: true
                },
                calculationType: {
                    type: "select",
                    name: "calculationType",
                    label: "Calculation",
                    path: "calculationType",
                    menu: [
                        {label: "Sum", value: "sum"},
                        {label: "Count", value: "count"},
                        {label: "Average", value: "avg"},
                    ],
                },
                format: {
                    type: "string",
                    name: "format",
                    label: "Format",
                    path: "format"
                },
                presentation: {
                    type: "select",
                    name: "presentation",
                    label: "Presentation",
                    path: "presentation",
                    menu: [
                        {label: "Button", value: "button"},
                        {label: "Checkbox", value: "checkbox"},
                        {label: "Progress", value: "progress"},
                    ],
                    disabled: false
                },
                width: {
                    type: "string",
                    name: "width",
                    label: "Width",
                    path: "width"
                }
            }
        }
    }

    componentDidCatch(error, errorInfo) {
        if (error) {
            this.setState({errorComponent: true});
            console.log('error', errorInfo)
        }
    }

    openEditColumn = (event, column, index) => {
        this.setState({columnInEdit: column, anchorEl: event.currentTarget, columnIndex: index})
    };

    closeEditColumn = () => {
        this.setState({columnInEdit: null, anchorEl: null, columnIndex: null})
    };

    //Form handler
    onChangeProps = (event, path, isCheckBox) => {
        const {columnInEdit} = this.state;
        const newValues = set(columnInEdit, path, isCheckBox === true ? event.target.checked : event.target.value);
        this.setState({columnInEdit: newValues})
    };

    renderFormEditColumn = () => {
        const {anchorEl, columnInEdit, columnSchema} = this.state;
        const {classes} = this.props;
        return (
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                PaperProps={{
                    style: {maxWidth: 610}
                }}
                onClose={this.closeEditColumn}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <table className={classes.table}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>{columnSchema.label.label}</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.label}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.label.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>{columnSchema.calculationType.label}</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.calculationType}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.calculationType.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>{columnSchema.format.label}</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.format}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.format.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>{columnSchema.presentation.label}</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.presentation}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.presentation.path}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td className={classes.tableCellLabel}>{columnSchema.width.label}</td>
                        <td className={classes.tableCell}>
                            <FormField
                                field={columnSchema.width}
                                values={columnInEdit || {}}
                                onChange={this.onChangeProps}
                                path={columnSchema.width.path}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>

                {this.formAction()}
            </Popover>
        )
    };

    formAction = () => {
        const {classes, setValuesProps} = this.props;
        const {columnInEdit, columnIndex} = this.state;
        return (
            <div className={classes.formActionsWrapper}>
                <Button size={"small"} variant="contained" color="primary" onClick={() => {
                    setValuesProps(columnInEdit, columnIndex);
                    this.closeEditColumn();
                }}>Apply</Button>
                <Button size={"small"} variant="contained" color="default" onClick={this.closeEditColumn}
                        style={{margin: "0 0 0 10px"}}>
                    Cancel
                </Button>
            </div>
        )
    };

    renderFilterColumns = () => {
        const {classes, valuesColumns} = this.props;
        return (
            (valuesColumns || []).map((column, index) => {
                return (
                    <React.Fragment key={`values_${column.field}_${index}`}>
                        <Draggable
                            draggableId={`${column.field}_values`}
                            index={index}>
                            {(provided, snapshot) => (
                                <>
                                    <ListItem
                                        classes={{dense: classes.listItemDense}}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        selected={snapshot.isDragging}
                                        onDoubleClick={(event) => this.openEditColumn(event, column, index)}
                                    >
                                        <ListItemText primary={column.label}/>
                                        <IconButton
                                            onClick={(event) => this.openEditColumn(event, column, index)}
                                            classes={{root: classes.editIcon}}>
                                            <Icon fontSize={"small"}>
                                                more_vert
                                            </Icon>
                                        </IconButton>
                                    </ListItem>
                                    <Divider/>
                                </>
                            )}
                        </Draggable>
                    </React.Fragment>
                )
            })
        )
    };

    render() {
        const {classes, valuesColumns} = this.props;
        const {errorComponent} = this.state;
        return (
            errorComponent ? (
                <p>Something bad with valueColumns component</p>
            ) : (
                <Card className={classes.fieldset}>
                    <legend style={{fontWeight: 'bold'}}>
                        Values
                    </legend>
                    <Divider/>
                    <Droppable droppableId={'valuesColumns'}>
                        {(provided) => (
                            <div className={classes.cardContentWrapper}
                                 {...provided.droppableProps}
                                 ref={provided.innerRef}>
                                <List dense={true}
                                      className={classes.list}
                                >
                                    <RenderColumns
                                        openEditColumn={this.openEditColumn}
                                        valuesColumns={valuesColumns}
                                    />
                                </List>
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                    {this.renderFormEditColumn()}
                </Card>
            )
        )
    }
}

const RenderColumns = ({valuesColumns = [], openEditColumn}) => {
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);

    return (
        valuesColumns.map((column, index) => {
            const multiLanguageLabel = multiLanguageValue(column.label, userLanguage)
            return (
                <React.Fragment key={`pivot_${column.name}_${index}`}>
                    <Draggable
                        draggableId={`${column.name}_pivot`}
                        index={index}>
                        {(provided, snapshot) => (
                            <>
                                <ListItem
                                    classes={{dense: classes.listItemDense}}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    selected={snapshot.isDragging}
                                    onDoubleClick={(event) => openEditColumn(event, column, index)}
                                >
                                    <ListItemText
                                        primary={multiLanguageLabel}
                                    />
                                    <IconButton
                                        size={"small"}
                                        onClick={(event) => openEditColumn(event, column, index)}
                                        classes={{root: classes.editIcon}}>
                                        <Icon fontSize={"small"}>
                                            more_vert
                                        </Icon>
                                    </IconButton>
                                </ListItem>
                                <Divider/>
                            </>
                        )}
                    </Draggable>
                </React.Fragment>
            )
        })
    )
}

export default withStyles(styles)(ValuesColumns)
